import { Col, Row, Typography } from "antd";
import { useSelector } from "react-redux";
import { Cell, Legend, Pie, PieChart } from "recharts";
import { RootState } from "store/Reducers";
import { useGetMostViewAdvertTypes } from "../../ServerSideStates";
import { useEffect, useState } from "react";
import CustomNoData from "apps/Common/CustomNoData";
import PageTitle from "apps/Common/PageTitle";

const MostViewedAdType = () => {
  const {filter} = useSelector((state:RootState)=>state.marketAnalysisRepor)
  const reports = useGetMostViewAdvertTypes(filter)
  const [data,setData] = useState<any[]>([])

  useEffect(()=>{
    if(reports?.data)
    {
      const allData = reports?.data?.data
      const formattedData = allData.map((item:any)=>{
        return{
          name:item.advertType,
          value:item.percentage
        }
      })
      setData(formattedData)
    }
  },[reports.data])
    
    
      const COLORS = ['#2979ff', '#ff5252', '#66bb6a', '#ffeb3b']; 


  return (
    <>
      <Row className="!shadow-lg !rounded-md !p-4 !bg-gray-50 ">
        <Col span={24} className="!flex !justify-center md:!justify-start" >
        <PageTitle
        title="En Çok İncelenen İlan Tipi"
        textClassNames="!text-gray-400"
        
        />
   
        </Col>
        {
          data?.length>0?<>
          
        <Col xs={24}>
        <PieChart width={500} height={300}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        innerRadius={60}
        outerRadius={80}
        dataKey="value"
        paddingAngle={5}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Legend 
        verticalAlign="middle" 
        layout="vertical" 
        align="right" 
        iconType="circle" 
      />
    </PieChart>
        </Col>
          </>:<>
          <CustomNoData/>
          </>
        }
      </Row>
    </>
  );
};

export default MostViewedAdType;
